import React from 'react';
import PropTypes from 'prop-types';
import SVGElement from './SVGElement';
import colors from '../../styling/colors';

const Checkmark = ({
  className,
  height = '1.5rem',
  strokeColor = colors('lapel'),
  width = '1.5rem',
}) => (
  <SVGElement
    className={className}
    height={height}
    width={width}
    viewBox="0 0 24 24"
  >
    <path
      fill={strokeColor}
      fillRule="nonzero"
      clipRule="evenodd"
      d="M10.55 16.934l8.6-9.2c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0l-8.3 8.8-3.3-3.8c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7l3.6 4.1c.2.2.5.2.8.1z"
    />
  </SVGElement>
);

Checkmark.propTypes = {
  className: PropTypes.string,
  height: PropTypes.string,
  strokeColor: PropTypes.string,
  width: PropTypes.string,
};

export default Checkmark;
